// ===================================
// MARQUEE SLIDER - OHNE REQUIRE/IMPORT
// ===================================

// @ts-nocheck

// KORRIGIERT: Alle require/import durch globale Variablen ersetzt
// const Flickity = require('../vendor/flickity') // ← ENTFERNT
// import { query, queryAll } from '../abstract/dom' // ← ENTFERNT

// ===================================
// DOM HELPER FUNCTIONS
// ===================================

function query(selector, context = document) {
	return context.querySelector(selector)
}

function queryAll(selector, context = document) {
	return Array.from(context.querySelectorAll(selector))
}

// ===================================
// HOVER DETECTION
// ===================================

// KORRIGIERT: Sichere Media Query mit Fallback
const canHover = (function() {
	try {
		return window.matchMedia && window.matchMedia('(hover: hover)').matches
	} catch (error) {
		// Fallback für ältere Browser
		console.warn('matchMedia nicht unterstützt - verwende Touch-Detection Fallback')
		return !('ontouchstart' in window || navigator.maxTouchPoints > 0)
	}
})()

console.log('🖱️ Hover-Unterstützung erkannt:', canHover)

// ===================================
// MARQUEE SLIDER INITIALISIERUNG
// ===================================

function initMarqueeSliders() {
	// Prüfen ob Flickity verfügbar ist
	if (typeof Flickity === 'undefined') {
		console.error('❌ Flickity nicht gefunden für Marquee Slider')
		console.log('💡 Stelle sicher, dass Flickity in vendor files geladen ist')
		return
	}
	
	console.log('🎠 Initialisiere Marquee Slider')
	
	queryAll('.slider-marquee').forEach((marquee, index) => {
		try {
			console.log(`🔧 Setup Marquee Slider ${index + 1}:`, marquee)
			
			// ===================================
			// MARQUEE STATE VARIABLES
			// ===================================
			
			let hoverFocusing = false
			let settled = true
			let lastTime
			let animationId = null
			
			// ===================================
			// ANIMATION LOOP
			// ===================================
			
			function play(time) {
				if (lastTime !== undefined) {
					if (!hoverFocusing && settled && ticker && ticker.isActive) {
						// KORRIGIERT: Sichere Geschwindigkeitsberechnung
						const deltaTime = time - lastTime
						const fps60Factor = deltaTime / (1000 / 60)
						const offset = 1 * fps60Factor // Geschwindigkeit anpassbar
						
						// Defensive Programmierung für ticker properties
						if (typeof ticker.x === 'number') {
							ticker.x = ticker.x - offset
							
							// Sichere settle-Methode
							if (typeof ticker.settle === 'function') {
								ticker.settle(ticker.x)
							}
						}
					}
				}
				
				lastTime = time
				animationId = requestAnimationFrame(play)
			}
			
			// ===================================
			// FLICKITY SETUP
			// ===================================
			
			const ticker = new Flickity(marquee, {
				accessibility: true,
				resize: true,
				wrapAround: true,
				freeScroll: true,
				prevNextButtons: false,
				pageDots: false,
				setGallerySize: true,
			})
			
			console.log('✅ Marquee Flickity initialisiert:', {
				element: marquee,
				cells: ticker.cells.length,
				canHover: canHover
			})
			
			// ===================================
			// TOUCH/DRAG EVENT HANDLERS
			// ===================================
			
			/**
			 * PREVENT IOS SCROLL WHEN SWIPING
			 * also works with the window listener in app.js
			 * https://github.com/metafizzy/flickity/issues/740#issuecomment-442202965
			 */
			
			ticker.on('dragStart', () => {
				console.log('🖱️ Marquee drag start')
				
				// Sichere Touch-Prevention
				try {
					document.ontouchmove = function(e) {
						e.preventDefault()
						return false
					}
				} catch (error) {
					console.warn('Touch prevention fehlgeschlagen:', error)
				}
				
				settled = false
			})
			
			ticker.on('settle', () => {
				console.log('⚖️ Marquee settled')
				settled = true
			})
			
			ticker.on('dragEnd', () => {
				console.log('🖱️ Marquee drag end')
				
				// Touch-Events wieder aktivieren
				try {
					document.ontouchmove = function() {
						return true
					}
				} catch (error) {
					console.warn('Touch restoration fehlgeschlagen:', error)
				}
				
				// Auf Touch-Geräten Focus zurücksetzen
				if (!canHover) {
					hoverFocusing = false
				}
			})
			
			// ===================================
			// FOCUS EVENT HANDLERS
			// ===================================
			
			ticker.element.addEventListener('focusin', (event) => {
				event.preventDefault()
				hoverFocusing = true
				
				console.log('🎯 Marquee focus in')
				
				// KORRIGIERT: event.srcElement → event.target
				const cellElement = event.target.closest('.cell')
				
				if (cellElement && ticker.isActive) {
					const cellInstance = ticker.getCell(cellElement)
					
					if (cellInstance) {
						const cellIndex = ticker.getCellSlideIndex(cellInstance)
						
						if (cellIndex !== ticker.selectedIndex && cellIndex !== -1) {
							ticker.select(cellIndex, false, true)
						}
					}
				}
				
				// Sichere Focus-Methode
				if (event.target && event.target.focus) {
					try {
						event.target.focus({
							preventScroll: true,
						})
					} catch (error) {
						// Fallback für ältere Browser
						event.target.focus()
					}
				}
			})
			
			ticker.element.addEventListener('focusout', (event) => {
				console.log('🎯 Marquee focus out')
				hoverFocusing = false
			})
			
			// ===================================
			// HOVER EVENT HANDLERS (NUR FÜR HOVER-GERÄTE)
			// ===================================
			
			/**
			 * ONLY TRACK MOUSEOVER/MOUSEOUT on HOVER DEVICES
			 * https://stackoverflow.com/a/52854585
			 */
			if (canHover) {
				console.log('🖱️ Hover-Events für Marquee aktiviert')
				
				ticker.element.addEventListener('mouseover', () => {
					console.log('🖱️ Marquee mouse over')
					hoverFocusing = true
				})
				
				ticker.element.addEventListener('mouseout', () => {
					console.log('🖱️ Marquee mouse out')
					hoverFocusing = false
				})
			} else {
				console.log('📱 Touch-Gerät - Hover-Events deaktiviert')
			}
			
			// ===================================
			// ANIMATION START
			// ===================================
			
			// Initialisiere Position
			ticker.x = 0
			
			// Starte Animation
			animationId = requestAnimationFrame(play)
			
			console.log('✅ Marquee Slider erfolgreich gestartet')
			
			// ===================================
			// CLEANUP BEI UNLOAD (OPTIONAL)
			// ===================================
			
			// Speichere Cleanup-Funktion für später
			ticker._cleanupAnimation = function() {
				if (animationId) {
					cancelAnimationFrame(animationId)
					animationId = null
					console.log('🧹 Marquee Animation gestoppt')
				}
			}
			
		} catch (error) {
			console.error('❌ Fehler beim Initialisieren Marquee Slider:', error)
			console.error('   Marquee Element:', marquee)
		}
	})
}

// ===================================
// PERFORMANCE OPTIMIERUNG
// ===================================

// Intersection Observer für bessere Performance
function setupMarqueePerformanceOptimization() {
	if (typeof IntersectionObserver === 'undefined') {
		console.log('⚠️ IntersectionObserver nicht verfügbar - keine Performance-Optimierung')
		return
	}
	
	const marqueeObserver = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			const marquee = entry.target
			const flickityInstance = Flickity.data(marquee)
			
			if (flickityInstance) {
				if (entry.isIntersecting) {
					// Marquee ist sichtbar - Animation läuft normal
					console.log('👁️ Marquee sichtbar - Animation aktiv')
				} else {
					// Marquee nicht sichtbar - könnte pausiert werden
					console.log('👁️ Marquee nicht sichtbar')
					// Optional: Animation pausieren für bessere Performance
					// flickityInstance._cleanupAnimation?.();
				}
			}
		})
	}, {
		rootMargin: '50px' // Starte Animation etwas vor Sichtbarkeit
	})
	
	// Beobachte alle Marquee Slider
	queryAll('.slider-marquee').forEach((marquee) => {
		marqueeObserver.observe(marquee)
	})
}

// ===================================
// RESIZE HANDLING
// ===================================

function handleMarqueeResize() {
	queryAll('.slider-marquee').forEach((marquee) => {
		const flickityInstance = Flickity.data(marquee)
		if (flickityInstance && typeof flickityInstance.resize === 'function') {
			flickityInstance.resize()
			console.log('🔄 Marquee resized')
		}
	})
}

// Debounced resize
function debounce(func, wait) {
	let timeout
	return function executedFunction(...args) {
		const later = () => {
			clearTimeout(timeout)
			func(...args)
		}
		clearTimeout(timeout)
		timeout = setTimeout(later, wait)
	}
}

window.addEventListener('resize', debounce(handleMarqueeResize, 250))

// ===================================
// DEBUGGING FUNKTIONEN
// ===================================

window.debugMarqueeSliders = function() {
	console.group('🔍 Marquee Slider Debug')
	
	const marquees = queryAll('.slider-marquee')
	console.log('Gefundene Marquee Slider:', marquees.length)
	console.log('Hover-Unterstützung:', canHover)
	console.log('Touch-Gerät:', !canHover)
	
	marquees.forEach((marquee, index) => {
		const flickityInstance = Flickity.data(marquee)
		
		console.log(`Marquee ${index}:`, {
			element: marquee,
			flickityInstance: !!flickityInstance,
			cells: flickityInstance ? flickityInstance.cells.length : 'N/A',
			isActive: flickityInstance ? flickityInstance.isActive : 'N/A',
			x: flickityInstance ? flickityInstance.x : 'N/A'
		})
	})
	
	console.groupEnd()
}

// ===================================
// CLEANUP FUNKTIONEN
// ===================================

window.cleanupMarqueeSliders = function() {
	console.log('🧹 Cleanup Marquee Slider')
	
	queryAll('.slider-marquee').forEach((marquee) => {
		const flickityInstance = Flickity.data(marquee)
		if (flickityInstance) {
			// Cleanup Animation
			if (typeof flickityInstance._cleanupAnimation === 'function') {
				flickityInstance._cleanupAnimation()
			}
			
			// Destroy Flickity
			if (typeof flickityInstance.destroy === 'function') {
				flickityInstance.destroy()
			}
		}
	})
}

// ===================================
// INITIALISIERUNG
// ===================================

function startMarqueeSliders() {
	console.log('🎬 Starte Marquee Slider System')
	
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function() {
			console.log('📄 DOM Ready - Initialisiere Marquee Slider')
			initMarqueeSliders()
			setupMarqueePerformanceOptimization()
			
			// Debug nach kurzer Verzögerung
			setTimeout(() => {
				if (typeof window.debugMarqueeSliders === 'function') {
					window.debugMarqueeSliders()
				}
			}, 1000)
		})
	} else {
		console.log('📄 DOM bereits geladen - Initialisiere Marquee Slider sofort')
		initMarqueeSliders()
		setupMarqueePerformanceOptimization()
		
		// Debug nach kurzer Verzögerung
		setTimeout(() => {
			if (typeof window.debugMarqueeSliders === 'function') {
				window.debugMarqueeSliders()
			}
		}, 1000)
	}
}

// Warten auf Flickity
if (typeof Flickity !== 'undefined') {
	startMarqueeSliders()
} else {
	// Polling für Flickity
	let attempts = 0
	const maxAttempts = 50
	
	const waitForFlickity = setInterval(() => {
		attempts++
		
		if (typeof Flickity !== 'undefined') {
			clearInterval(waitForFlickity)
			console.log('✅ Flickity für Marquee geladen nach', attempts, 'Versuchen')
			startMarqueeSliders()
		} else if (attempts >= maxAttempts) {
			clearInterval(waitForFlickity)
			console.error('❌ Flickity konnte nicht geladen werden nach', maxAttempts, 'Versuchen')
		}
	}, 100)
}

// ===================================
// PAGE UNLOAD CLEANUP
// ===================================

window.addEventListener('beforeunload', () => {
	if (typeof window.cleanupMarqueeSliders === 'function') {
		window.cleanupMarqueeSliders()
	}
})